<section class="related" id="related">
  <div class="related__title">
    <h1>Related Products</h1>
  </div>

  <div class="list">
    <div *ngFor="let product of relatedProducts; let i = index" data-aos="fade-up" data-aos-duration="500" class="related__card">
      <div class="related__card__title">
        <img [src]="product.frontViewImageUrl" alt="">
      </div>
      <div class="related__card__doses">
        <h2>{{product.productName}}</h2>
      </div>
      <div class="related__card__doses__details">

        <app-button classList="btn rounded bordered bg-white" text="Go to product page" [href]="'http://'+product.domain+'.evapharma.com'"></app-button>

      </div>

    </div>
<!--
    <div data-aos="fade-up" data-aos-duration="700" class="related__card">
        <div class="related__card__title">
          <img src="../../../assets/genuphil box 1.svg" alt="">
        </div>
        <div class="related__card__doses">
          <h2>Product Name</h2>
        </div>
        <div class="related__card__doses__details">

          <app-button classList="btn rounded bordered bg-white" text="Go to product page"></app-button>

        </div>

      </div>

      <div data-aos="fade-up" data-aos-duration="500" class="related__card">
        <div class="related__card__title">
          <img src="../../../assets/genuphil box 1.svg" alt="">
        </div>
        <div class="related__card__doses">
          <h2>Product Name</h2>
        </div>
        <div class="related__card__doses__details">

          <app-button classList="btn rounded bordered bg-white" text="Go to product page"></app-button>

        </div>

      </div> -->

  </div>
</section>
